import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import { getUserMenuList } from "../../application/selectors/user";
import DefaultApiService from "../../infrastructure/api/default";
import {
  getUserDefaultUrl,
  isMainMenuHiddenForUser,
  readStoredUser,
} from "../../infrastructure/utils/authSession";
import Dashboard from "../components/dashboard";

const Home = () => {
  const menuList = useSelector(getUserMenuList);
  const [loading, setLoading] = useState(false);
  const [dataList, setDataList] = useState([]);
  const user = readStoredUser();
  const defaultUrl = getUserDefaultUrl(user);
  const shouldRedirectToDefault =
    defaultUrl &&
    defaultUrl !== "/" &&
    isMainMenuHiddenForUser(user);

  useEffect(() => {
    if (shouldRedirectToDefault) {
      return undefined;
    }

    let cancelled = false;

    setLoading(true);
    DefaultApiService.getApi("Home/GetData", {}, true)
      .then((res) => {
        if (cancelled) return;
        if (res?.data?.dataList) {
          setDataList(res.data.dataList);
        }
      })
      .catch(() => {
        // dashboard data is optional; don't block the page
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [shouldRedirectToDefault]);

  if (shouldRedirectToDefault) {
    return <Navigate to={defaultUrl} replace />;
  }

  return (
    <Grid container className="home-container" spacing={3}>
      <Grid item xs={12} md={12}>
        <Dashboard
          menuList={menuList}
          cartTitle="داشبورد"
          blockList={dataList}
          loading={loading}
        />
      </Grid>
    </Grid>
  );
};

export default Home;
